
import Gutter from '@/ui-kit/components/gutter/index';
import { StylePositionType, StyleSizeType } from '@/ui-kit/styles/enums';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import LoadingSpinner from '@/components/LoadingSpinner';
import { LayoutItemColumn } from '@/ui-kit/components/layout-grid/item/enums';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';

export default {
  name: 'Chart',
  components: {
    Gutter,
    LoadingSpinner,
    apexcharts: () => (process.client ? import('vue-apexcharts') : null),
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
      default: 'Loading chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '400px',
    },
  },
  data() {
    return {
      chartRef: null,
      removeExportListeners: null,
      TypographyType,
      StyleSizeType,
      StylePositionType,
      LayoutItemColumn,
      GutterProperty,
    };
  },
  computed: {
    chartStyle() {
      return {
        width: this.width,
        minHeight: this.height,
      };
    },
  },
  updated() {
    this.chartRef = this.$refs.chartRef;
    if (this.chartRef) {
      this.wireExportButtonListeners();
    }
  },
  destroyed() {
    this.removeExportListeners?.();
    this.removeExportListeners = null;
    this.$refs.chartRef?.destroy();
  },
  methods: {
    wireExportButtonListeners() {
      const hamburgerMenu = document.querySelector('.apexcharts-menu');
      if (!hamburgerMenu) {
        return;
      }
      const exportCSVButton = hamburgerMenu.querySelector('.exportCSV');
      if (exportCSVButton) {
        exportCSVButton.addEventListener('click', this.handleExportClick);
        this.removeExportListeners = () => exportCSVButton.removeEventListener('click', this.handleExportClick);
      }
    },
    handleExportClick() {
      this.$emit('export');
    },
  },
};
